import { useMemo } from "react";
import { useAuth } from "@/hooks/use-auth";
import { currentBrand, type BrandConfig } from "@/lib/brand";

/**
 * Returns the active BrandConfig for the current user.
 * If the user has white-label enabled and a name set, their custom
 * branding (name, tagline, logo, colours) overrides the defaults.
 */
export function useBrand(): BrandConfig {
  const { profile } = useAuth();

  return useMemo((): BrandConfig => {
    if (profile?.white_label_enabled && profile.white_label_name) {
      return {
        ...currentBrand,
        name: profile.white_label_name,
        tagline: profile.white_label_tagline ?? currentBrand.tagline,
        logoSrc: profile.white_label_logo_url ?? currentBrand.logoSrc,
        primaryColor: profile.white_label_primary_color ?? currentBrand.primaryColor,
        accentColor: profile.white_label_accent_color ?? currentBrand.accentColor,
      };
    }
    return currentBrand;
  }, [profile]);
}
